export default "__VITE_ASSET__Ciq9d2Lc__"